import { useEffect } from 'react';

const useDocumentTitle = (title = ''): void => {
  useEffect(() => {
    // TODO: why not !!title ?
    if (title.includes('undefined')) {
      document.title = 'Import.io';
    } else {
      document.title = title;
    }
  }, [title]);
};

export default useDocumentTitle;
